import { ReactElement } from "react";
import { useHistory } from "react-router-dom";
import StatusIndicator from "../../../../components/Shared/StatusIndicator";
import useWindowWidth from "../../../../hooks/UseWindowWidth";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import { className } from "../../../../shared/helpers";
import styles from "./Header.module.scss";

interface HeaderProps
{
    component: IComponent;
    sidenavHidden: boolean;
    setSidenavHidden: (sidenavStatus: boolean) => void;
}

const Header = (props: HeaderProps): ReactElement =>
{
    const history = useHistory();
    const isDesktop = useWindowWidth(992);

    return (
        <div className={styles.header}>
            <div className={styles.headerTitleWrapper} onClick={() => history.push("/dashboard/")}>
                <span className={styles.title}>{props.component.name}</span>

                <StatusIndicator
                    component={props.component}
                    customClassName={styles.statusIndicator}
                    inverted={isDesktop}
                />
            </div>

            <div className={styles.togglerContainer}>
                <button
                    onClick={() => props.setSidenavHidden(!props.sidenavHidden)}
                    {...className("icon-btn", styles.togglerButton, {
                        [styles.isOpened]: !props.sidenavHidden
                    })}
                >
                    <i className="material-icons">{props.sidenavHidden ? "expand_more" : "close"}</i>
                </button>
            </div>
        </div>
    )
};

export default Header;
